export default "__VITE_ASSET__CgVC0RCp__"